import lightGallery from 'lightgallery'
// import { lightGallery } from '../../../node_modules/lightgallery/lightgallery.es5.js'
// import lgZoom from 'lightgallery/plugins/zoom'
// import lgAutoplay from 'lightgallery/plugins/autoplay'
// import lgComment from 'lightgallery/plugins/comment'
// import lgFullscreen from 'lightgallery/plugins/fullscreen'
import lgHash from 'lightgallery/plugins/hash'
// import lgPager from 'lightgallery/plugins/pager'
// import lgRotate from 'lightgallery/plugins/rotate'
// import lgShare from 'lightgallery/plugins/share'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
// import lgVideo from 'lightgallery/plugins/video'
// import lgMediumZoom from 'lightgallery/plugins/mediumZoom'
import { createFocusTrap } from '../../node_modules/focus-trap/dist/focus-trap.esm.js'

const galleries = document.querySelectorAll('[data-gallery="gallery"]')
const sliders = document.querySelectorAll('[data-gallery="slider"]')
let uniqueId = 0
for (const item of galleries) {
	const galleryInstance = lightGallery(item, {
		plugins: [lgHash],
		speed: 450,
		startAnimationDuration: 250,
		galleryId: uniqueId,
		mode: 'lg-soft-zoom',
		download: false,
		selector: '.c-figure__link',
	})

	// Add Focus Trap on gallery
	const focusTrapGallery = createFocusTrap(
		`#lg-container-${galleryInstance.lgId}`
	)
	item.addEventListener('lgAfterOpen', () => {
		focusTrapGallery.activate()
	})

	item.addEventListener('lgAfterClose', () => {
		focusTrapGallery.deactivate()
	})
	uniqueId += 1
}

for (const item of sliders) {
	const galleryInstance = lightGallery(item, {
		plugins: [lgThumbnail],
		container: '.c-gallery',
		hash: false,
		closable: false,
		speed: 450,
		startAnimationDuration: 250,
		galleryId: uniqueId,
		mode: 'lg-slide',
		download: false,
		selector: '.c-figure__link',
		// Thumbnail settings
		exThumbImage: 'data-thumbnail',
		thumbHeight: '64px',
		thumbWidth: 80,
		allowMediaOverlap: true,
		counter: false,
	})

	galleryInstance.openGallery()
	uniqueId += 1
}
